import { Checkbox, CheckboxGroup, Card, SubmitBar } from 'vant';
import { ref } from 'vue';
import { useList } from "../../api/user";
export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup
  },
  setup() {
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const refreshing = ref(false);
    const listQuery = {
      page: 1,
      limit: 20
    };
    const onLoad = () => {
      useList(listQuery).then(response => {
        console.log(response);
        listQuery.page++;
        if (refreshing.value) {
          list.value = [];
          refreshing.value = false;
        }
        list.value = list.value.concat(response.data.data);
        loading.value = false;
        if (response.data.data.length === 0) {
          finished.value = true;
        }
      });
    };
    const onRefresh = () => {
      // 清空列表数据
      finished.value = false;
      listQuery.page = 1;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = true;
      onLoad();
    };
    return {
      list,
      onLoad,
      loading,
      finished,
      onRefresh,
      refreshing,
      listQuery
    };
  },
  created() {},
  data() {
    return {};
  },
  methods: {}
};